import React from 'react';
import { FileText } from 'lucide-react';
import Header from './components/Header21';
import Footer from './components/Footer21';

const TermsAndConditions21 = () => {
    const sections = [
        {
            id: 'general-terms',
            title: '1. General Terms',
            paragraphs: [
                'Welcome to our online fashion store. By accessing, browsing, or placing an order on this website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. These terms apply to all visitors, users, and customers of the website.',
                'We reserve the right to update, modify, or replace any part of these Terms and Conditions at our sole discretion. It is your responsibility to check this page periodically for changes. Your continued use of the website following the posting of any changes constitutes acceptance of those changes.',
                'If you do not agree with any of these terms, you are prohibited from using or accessing this website. The materials contained on this website are protected by applicable copyright and trademark law under the laws of India.'
            ]
        },
        {
            id: 'account-registration',
            title: '2. Account & Registration',
            paragraphs: [
                'To make a purchase on our website, you may be required to create an account by providing accurate, complete, and current information including your full name, email address, mobile number, and shipping address. You are solely responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.',
                'You must be at least 18 years of age to create an account and make purchases. By registering, you represent and warrant that all information you provide is truthful and accurate. We reserve the right to suspend or terminate accounts that contain false or misleading information.',
                'You agree to notify us immediately of any unauthorized use of your account or any other breach of security. We will not be liable for any loss or damage arising from your failure to comply with this provision.'
            ]
        },
        {
            id: 'orders-payment',
            title: '3. Orders & Payment',
            paragraphs: [
                'All orders placed through our website are subject to acceptance and availability. We reserve the right to refuse or cancel any order at our discretion, including orders where pricing errors have occurred, orders that appear to be placed by dealers or resellers, or orders that contain incorrect or unverifiable information.',
                'Prices for our products are quoted in Indian Rupees (INR) and are inclusive of applicable GST unless stated otherwise. Payment can be made via credit card, debit card, net banking, UPI, or Cash on Delivery (COD) where available. All online payments are securely processed through Razorpay, our trusted payment gateway, which employs industry-standard encryption and security protocols.',
                'Upon successful placement of an order, you will receive an order confirmation email with your order details and estimated delivery timeline. This confirmation does not constitute acceptance of your order; acceptance occurs only when the product has been dispatched from our facility.'
            ]
        },
        {
            id: 'shipping-delivery',
            title: '4. Shipping & Delivery',
            paragraphs: [
                'We endeavour to dispatch all orders within 2-5 business days from the date of order confirmation. Delivery timelines vary depending on your location and the shipping method selected at checkout. Standard delivery within India typically takes 5-7 business days, while express shipping takes 2-3 business days.',
                'For custom-made, made-to-order, or bespoke garments, additional production time of 7-21 business days may apply depending on the complexity of the design. You will be informed of the estimated delivery date at the time of order placement.',
                'Risk of loss and title for all items pass to you upon delivery to the shipping carrier. We partner with reputed logistics providers to ensure safe and timely delivery of your orders. In the event of a delivery delay caused by circumstances beyond our control, including but not limited to natural disasters, strikes, or government restrictions, we shall not be held liable.'
            ]
        },
        {
            id: 'returns-exchange',
            title: '5. Returns & Exchange',
            paragraphs: [
                'We accept exchange requests within 7 days of delivery, provided the item is unused, unwashed, and in its original condition with all tags, labels, and packaging intact. To initiate an exchange, please contact our customer support team with your order number and reason for exchange.',
                'Certain categories of products are not eligible for return or exchange, including but not limited to: customised or made-to-order garments, intimate wear, accessories marked as non-returnable, and products purchased during clearance or final sale events. Please check the product page for specific return eligibility before placing your order.',
                'Refunds, where applicable, will be processed within 7-10 business days of receiving the returned product at our facility. The refund will be credited to your original payment method. For COD orders, refunds will be processed via bank transfer to the account details provided by you.'
            ]
        },
        {
            id: 'intellectual-property',
            title: '6. Intellectual Property',
            paragraphs: [
                'All content on this website, including but not limited to text, graphics, logos, images, photographs, product designs, patterns, illustrations, audio, video, software, and compilation thereof, is the exclusive property of our brand and is protected under Indian and international intellectual property laws, including the Copyright Act, 1957 and the Trade Marks Act, 1999.',
                'You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our website without our prior written consent. Any unauthorized use of the materials appearing on this website may violate copyright, trademark, and other applicable laws and could result in criminal or civil penalties.',
                'Our original textile designs, embroidery patterns, and garment silhouettes are proprietary creations. Any attempt to replicate, reverse-engineer, or commercially exploit our designs without express written permission constitutes infringement and will be pursued through appropriate legal channels.'
            ]
        },
        {
            id: 'limitation-liability',
            title: '7. Limitation of Liability',
            paragraphs: [
                'To the maximum extent permitted by applicable law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of (or inability to access or use) our website or services.',
                'We do not warrant that the website will be uninterrupted, timely, secure, or error-free, or that defects will be corrected. We are not responsible for any damage to your computer system, mobile device, or data that results from your use of the website. Our total liability for any claims arising from or related to these terms shall not exceed the amount paid by you for the specific product or service giving rise to the claim.',
                'Notwithstanding the foregoing, nothing in these terms shall limit or exclude our liability for death or personal injury caused by our negligence, fraud or fraudulent misrepresentation, or any other liability that cannot be excluded or limited by applicable Indian law.'
            ]
        },
        {
            id: 'governing-law',
            title: '8. Governing Law',
            paragraphs: [
                'These Terms and Conditions shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts located in the city where our registered office is situated.',
                'In the event of any dispute or claim arising from or relating to these Terms and Conditions, the parties shall first attempt to resolve the matter amicably through good-faith negotiations. If the dispute cannot be resolved within 30 days, either party may refer the matter to arbitration in accordance with the Arbitration and Conciliation Act, 1996.',
                'If any provision of these Terms and Conditions is found to be invalid or unenforceable by a court of competent jurisdiction, the remaining provisions shall continue in full force and effect. Our failure to enforce any right or provision of these terms shall not constitute a waiver of such right or provision.'
            ]
        }
    ];

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500&family=DM+Sans:wght@300;400;500;600;700&display=swap');
            `}</style>
            <div style={{ fontFamily: "'DM Sans', -apple-system, sans-serif" }} className="min-h-screen bg-[#0A0A0A]">
                <Header />

                <main>
                    {/* Hero Section */}
                    <section className="py-20 lg:py-28 px-4 lg:px-12 border-b border-[#2A2A2A]">
                        <div className="max-w-3xl mx-auto text-center">
                            <div className="w-16 h-16 border border-[#C9A96E]/30 rounded-full flex items-center justify-center mx-auto mb-8">
                                <FileText className="w-7 h-7 text-[#C9A96E]" />
                            </div>
                            <h1
                                style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
                                className="text-4xl lg:text-6xl font-light text-[#C9A96E] mb-6 tracking-wide"
                            >
                                Terms & Conditions
                            </h1>
                            <p className="text-[#8A8A7A] text-lg max-w-2xl mx-auto leading-relaxed">
                                Please read these terms and conditions carefully before using our website or placing an order.
                            </p>
                            <p className="text-[#8A8A7A]/60 text-sm mt-4 tracking-wide">
                                Last Updated: March 2026
                            </p>
                        </div>
                    </section>

                    {/* Table of Contents */}
                    <section className="py-12 lg:py-16 px-4 lg:px-12 border-b border-[#2A2A2A]">
                        <div className="max-w-3xl mx-auto">
                            <h2
                                style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
                                className="text-2xl font-light text-[#F5F0EB] mb-8 text-center"
                            >
                                Table of Contents
                            </h2>
                            <ol className="space-y-3">
                                {sections.map((section, index) => (
                                    <li key={index}>
                                        <button
                                            onClick={() => scrollToSection(section.id)}
                                            className="text-[#C9A96E] hover:text-[#D4B87A] transition-colors text-base lg:text-lg tracking-wide cursor-pointer text-left"
                                        >
                                            {section.title}
                                        </button>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </section>

                    {/* Sections */}
                    <section className="py-16 lg:py-24 px-4 lg:px-12">
                        <div className="max-w-3xl mx-auto">
                            <div className="space-y-16 lg:space-y-20">
                                {sections.map((section, index) => (
                                    <div key={index} id={section.id} className="scroll-mt-24">
                                        <h2
                                            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
                                            className="text-2xl lg:text-3xl font-light text-[#C9A96E] mb-8 tracking-wide"
                                        >
                                            {section.title}
                                        </h2>
                                        <div className="space-y-5">
                                            {section.paragraphs.map((paragraph, pIndex) => (
                                                <p
                                                    key={pIndex}
                                                    className="text-[#F5F0EB]/85 text-base leading-[1.7]"
                                                >
                                                    {paragraph}
                                                </p>
                                            ))}
                                        </div>
                                        {index < sections.length - 1 && (
                                            <div className="mt-16 lg:mt-20 border-b border-[#2A2A2A]" />
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Contact Section */}
                            <div className="mt-20 p-8 lg:p-10 bg-[#141414] border border-[#2A2A2A] rounded-lg">
                                <h3
                                    style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
                                    className="text-2xl font-light text-[#F5F0EB] mb-4"
                                >
                                    Questions About Our Terms?
                                </h3>
                                <p className="text-[#8A8A7A] mb-6 leading-relaxed">
                                    If you have any questions or concerns about these Terms and Conditions, please do not hesitate to contact us.
                                </p>
                                <p className="text-[#C9A96E] font-medium">
                                    Email: legal@yourbrand.com
                                </p>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default TermsAndConditions21;
